import type { UUID } from "utils";

const BASE_URL = "/configuration/customers/:id/cash-management";
const ACCOUNT_BASE_URL = `${BASE_URL}/account`;
const PROVIDER_CONFIG_BASE_URL = `${BASE_URL}/provider-config`;

export const PAGE_URLS = {
  accountCreate: `${ACCOUNT_BASE_URL}/create`,
  accountDetails: `${ACCOUNT_BASE_URL}/:accountId`,
  accountEdit: `${ACCOUNT_BASE_URL}/:accountId/edit`,
  details: BASE_URL,
  notifications: `${BASE_URL}/notifications-settings`,
  providerConfigList: PROVIDER_CONFIG_BASE_URL,
  providerConfigCreate: `${PROVIDER_CONFIG_BASE_URL}/create/:providerId`,
  providerConfigDetails: `${PROVIDER_CONFIG_BASE_URL}/:configId`,
  providerConfigEdit: `${PROVIDER_CONFIG_BASE_URL}/:configId/edit`,
  getAccountDetails: getAccount,
  getDetails,
  getNotifications: (customerId: UUID) =>
    `${getDetails(customerId)}/notifications-settings`,
  getProviderConfigList: getProviderConfig,
  getProviderConfigDetails: (customerId: UUID, configId: UUID) =>
    `${getProviderConfig(customerId)}/${configId}`,
};

function getDetails(customerId: UUID) {
  return `/configuration/customers/${customerId}/cash-management`;
}

function getAccount(customerId: UUID, accountId: UUID) {
  return `${getDetails(customerId)}/account/${accountId}`;
}

function getProviderConfig(customerId: UUID) {
  return `${getDetails(customerId)}/provider-config`;
}
